import { createUseStyles } from "react-jss";
import { colors } from "../../../../constants/colors";
import { breakpoints } from "../../../../constants/breakpoints";

const styles = createUseStyles(() => ({
  inlinePlaceholder: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: colors.inactiveGrey,
    marginLeft: 4,
    pointerEvents: "none",
  },
  noStates: {
    extend: "inlinePlaceholder",
    marginLeft: "-4px"
  },
  closeIconStyle: {
    cursor: "pointer",
    display: "flex",
    marginRight: "4px",
    padding: "2px",
  },
}));

export default styles;

export const selectField = {
  option: (base, state) => ({
    ...base,
    fontSize: "16px",
    img: {
      display: state.isSelected ? "inline" : "none",
      marginLeft: "6px",
    },
    display: "flex",
    flex: "none",
    justifyContent: "space-between",
    padding: "10px 8px",
    backgroundColor: state.isSelected ? colors.brightBlue : colors.white,
    borderRadius: "6px",
    color: colors.lightBlack,
    "&:hover": {
      backgroundColor: colors.brightBlue,
    },
  }),

  control: (base) => ({
    ...base,
    background: colors.white,
    borderRadius: "8px",
    borderColor: colors.darkGrey,
    "&:hover": {
      borderColor: colors.darkGrey,
    },
    "&.disabled": {
      background: colors.lightGrey,
    },
    boxShadow: null,
    minHeight: "40px",
    width: "400px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "300px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "350px",
    },
    padding: "8px 12px",
    flex: "none",
  }),

  multiValue: (base) => ({
    ...base,
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "6px",
    border: `1px solid ${colors.darkGrey}`,
    backgroundColor: colors.white,
  }),

  multiValueLabel: (base) => ({
    ...base,
    marginRight: "3px",
    paddingLeft: "9px",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: 500,
    color: colors.grey,
    padding: "0px",
  }),

  multiValueRemove: (base) => ({
    ...base,
    cursor: "pointer",
    pointerEvents: "all",
    ':hover': {
      backgroundColor: "transparent",
    }
  }),

  valueContainer: (base) => ({
    ...base,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: "0px",

    pointerEvents: "none",
  }),

  input: (styles) => ({
    ...styles,
    flex: "none",
    pointerEvents: "all",
    margin: "0px",
    padding: "0px"
  }),

  menu: (base) => ({
    ...base,
    width: "400px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "300px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "350px",
    },
  }),
};

export const statesSelectError = {
  control: (base) => ({
    ...base,
    border: `1px solid ${colors.mediumRed}`,
    borderRadius: "8px",
    "&:hover": {
      border: `1px solid ${colors.mediumRed}`,
    },
    boxShadow: null,
    minHeight: "40px",
    width: "400px",
    padding: "8px 12px",
    flex: "none",
  }),
};
